// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3AIMk","signatureBlock":"Footer_signatureBlock__32X-K","signature":"Footer_signature__1D-v0"};